module.exports = __webpack_public_path__ + "static/media/handball.be09a73f.jpg";